import styled from '@emotion/styled';
import Box from '@mui/material/Box';
import { getColor } from '../common/UICommon';

export const ContainerBox = styled(Box)`
  font-family: 'Poppins';
  padding: 0 24px;
`;

export const StepWrapperBox = styled(ContainerBox)`
  margin-bottom: 48px;

  @media (max-width: 600px) {
    margin-bottom: 0px;
  }
`;

export const ButtonHeightBox = styled(Box)`
  font-family: 'Poppins';
  height: 88px;
`;

export const LoaderDiv = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
`;

export const BoxWithLinearBorder = styled.div<{ enabled: boolean }>`
  position: relative;
  z-index: 0;

  &::before {
    content: '';
    position: absolute;
    z-index: -1;
    inset: 0;
    padding: 1px;
    border-radius: 8px;
    border: 2px solid transparent;
    background: ${({ enabled }) => (enabled ? getColor('PURPLE_GRADIENT') : 'transparent')};
    mask: linear-gradient(#fff 0 0) padding-box, linear-gradient(#fff 0 0);
    mask-composite: exclude;
  }
`;
